export const ACCORDION_TAB_SHORTCUTS_NOTES_TO_DETAILS: Readonly<
  Record<string, string>
> = {
  n: 'Notes',
  o: 'Statuscodes',
  t: 'Attachments',
  s: 'Events',
  l: 'Details',
};

export const ACCORDION_TAB_SHORTCUTS_MISCELLANEOUS: Readonly<
  Record<string, string>
> = { m: 'Miscellaneous' };

export const ACCORDION_TAB_SHORTCUTS_AP: Readonly<Record<string, string>> = {
  p: 'AP',
};

export const ACCORDION_TAB_SHORTCUTS_AR: Readonly<Record<string, string>> = {
  r: 'AR',
};
